import React, { useState } from "react";
import kedinasan from ".././../assets/materi tni polri/SEKOLAH_KEDINASAN.webp";
import "./Materi.css";

const MateriKedinasan = () => {
  // SEKDIN
  const [isDropdownSkdSekdin, setIsDropdownSkdSekdin] = useState(false);
  const [isDropdownJasmaniSekdin, setIsDropdownJasmaniSekdin] = useState(false);
  const [isDropdownAkademikSekdin, setIsDropdownAkademikSekdin] =
    useState(false);

  // SEKDIN
  const toggleDropdownSkdSekdin = () => {
    setIsDropdownSkdSekdin(!isDropdownSkdSekdin);
  };
  const toggleDropdownJasmaniSekdin = () => {
    setIsDropdownJasmaniSekdin(!isDropdownJasmaniSekdin);
  };
  const [openDropdown, setOpenDropdown] = useState(null);

  // Function to toggle the dropdown and close others
  const toggleDropdown2 = (dropdown) => {
    // If the clicked dropdown is already open, close it, else open it
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  return (
    <React.Fragment>
      <div className="container-materi">
        <h1 className="title-materi">
          Materi Akurat Lolos <br /> Sekolah Kedinasan
        </h1>
        <div className="box-materi">
          {/* SEKDIN */}
          <div className="child-card-materi-kedinasan">
            <div className="box-isi-materi">
              <h3
                className="dropdown-isi-materi"
                onClick={() => toggleDropdown2("skdSekdin")}
              >
                Seleksi Kompetensi Dasar{" "}
                <span>{openDropdown === "skdSekdin" ? "-" : "+"}</span>
              </h3>
              {openDropdown === "skdSekdin" && (
                <ul className="dropdown-content">
                  <li>Tes Intelegensi Umum</li>
                  <li>Tes Wawasan Kebangsaan</li>
                  <li>Tes Karakteristik Pribadi</li>
                </ul>
              )}
              <h3 className="dropdown-isi-materi">Psikotes</h3>
              <h3
                className="dropdown-isi-materi"
                onClick={() => toggleDropdown2("jasmaniSekdin")}
              >
                Jasmani{" "}
                <span>{openDropdown === "jasmaniSekdin" ? "-" : "+"}</span>
              </h3>
              {openDropdown === "jasmaniSekdin" && (
                <ul className="dropdown-content">
                  <li>Jasmani A</li>
                  <li>Jasmani B</li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MateriKedinasan;
